import { ElementApi, PathApi, type SlateEditor, TextApi } from '@udecode/plate';

import { BaseSuggestionPlugin } from '../BaseSuggestionPlugin';
import type { TResolvedSuggestion, TSuggestionText } from '../types';
import { getInlineSuggestionData } from '../utils';

export const acceptSuggestion = (
    editor: SlateEditor,
    description: TResolvedSuggestion
) => {
    editor.tf.withoutNormalizing(() => {
        const mergeNodes = [
            ...editor.api.nodes({
                at: [],
                match: (n) => {
                    if (!ElementApi.isElement(n)) return false;

                    if (
                        editor.getApi(BaseSuggestionPlugin).suggestion.isBlockSuggestion(n)
                    ) {
                        const sd = editor.getApi(BaseSuggestionPlugin).suggestion.suggestionData(n) as { type?: string; isLineBreak?: boolean; id?: string } | undefined;
                        return (
                            sd?.type === 'remove' &&
                            !!sd?.isLineBreak &&
                            sd?.id === description.suggestionId
                        );
                    }

                    return false;
                },
            }),
        ];

        mergeNodes.reverse().forEach(([, path]) => {
            editor.tf.mergeNodes({ at: PathApi.next(path) });
        });

        editor.tf.unsetNodes([description.keyId, BaseSuggestionPlugin.key], {
            at: [],
            mode: 'all',
            match: (n) => {
                if (TextApi.isText(n)) {
                    const suggestionDataList = editor
                        .getApi(BaseSuggestionPlugin)
                        .suggestion.dataList(n as TSuggestionText);

                    const includeUpdate = suggestionDataList.some(
                        (data) => data.type === 'update'
                    );

                    if (includeUpdate) {
                        return suggestionDataList.some(
                            (d) => d.id === description.suggestionId
                        );
                    } else {
                        const suggestionData = getInlineSuggestionData(n);

                        if (suggestionData)
                            return (
                                suggestionData.type === 'insert' &&
                                suggestionData.id === description.suggestionId
                            );
                    }

                    return false;
                }
                if (
                    ElementApi.isElement(n) &&
          editor.getApi(BaseSuggestionPlugin).suggestion.isBlockSuggestion(n)
                ) {
                    const sd = editor.getApi(BaseSuggestionPlugin).suggestion.suggestionData(n) as { type?: string; isLineBreak?: boolean; id?: string } | undefined;

                    if (sd) {
                        if (sd.isLineBreak)
                            return sd.id === description.suggestionId;

                        return (
                            sd.type === 'insert' &&
                            sd.id === description.suggestionId
                        );
                    }
                }

                return false;
            },
        });

        editor.tf.removeNodes({
            at: [],
            mode: 'all',
            match: (n) => {
                if (TextApi.isText(n)) {
                    const suggestionData = getInlineSuggestionData(n);

                    if (suggestionData) {
                        return (
                            suggestionData.type === 'remove' &&
                            suggestionData.id === description.suggestionId
                        );
                    }

                    return false;
                }

                if (
                    ElementApi.isElement(n) &&
          editor.getApi(BaseSuggestionPlugin).suggestion.isBlockSuggestion(n)
                ) {
                    const sd = editor.getApi(BaseSuggestionPlugin).suggestion.suggestionData(n) as { type?: string; isLineBreak?: boolean; id?: string } | undefined;

                    if (sd) {
                        return (
                            sd.type === 'remove' &&
                            sd.id === description.suggestionId &&
                            !sd.isLineBreak
                        );
                    }
                }

                return false;
            },
        });
    });
};
